import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface TariffListUpdatedAtHeaderProps
  extends HeaderContext<TariffModel, TariffModel['updatedAt']> {}

export const TariffListUpdatedAtHeader =
  (): // props: TariffListUpdatedAtHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-base-with-timestamp.updated-at');
  };
